import React from "react";

class Testiclass extends React.Component {
  render() {
    return <div className="copyright">Copyright © Marita Ifemeni 2022</div>;
  }
}

export default Testiclass;
